module.exports = __webpack_public_path__ + "static/media/male.7da41969.svg";